import {cc}             from "@Common/react/callback-chain";
import {getNestedValue} from "@Common/utils/arr-path";
import {chain}          from "@Common/utils/fs";
import {isSuperSmall}   from "@Common/utils/math/is-super-small";

export const getSelectedCards = ({cart, cards, remainingAmount}) => cc([
    (_, next) => {
        if (isSuperSmall(remainingAmount)) {
            return [];
        }
        return next();
    },
    () => {
        const selectedCards = getNestedValue(cart, ["appliedPayments", "creditCards"]);

        if (!selectedCards?.length && cards.length) {
            return chain(
                cards.find((c) => c.isDefaultCard && !c.isExpiredCard),
                (_) => _ ?? cards.find((c) => !c.isExpiredCard),
                (_) => _ ? [_] : [],
            );
        }

        return selectedCards;
    },
]);
